export const hasProcessorPermission = (
  feature: "installment" | "retroactive" | "antecipateSales",
  currentProcessor: "cards" | "dock" | "horizon"
): boolean => {
  const rawData = sessionStorage.getItem("@SAC_RPE_PERMISSION_MANAGEMENT");

  if (!rawData) return false;

  try {
    const permissions = JSON.parse(rawData);
    const { apiData } = permissions;

    if (!Array.isArray(apiData)) return false;

    const slugMap = {
      installment: "use_custom_initial_value_in_installment",
      retroactive: "permission_launch_adjustment_with_previous_date",
      antecipateSales: "permission_antecipate_sales",
    };

    const targetSlug = slugMap[feature];

    const featureData = apiData.find((item: any) => item.slug === targetSlug);

    if (!featureData) return false;

    const isDock = currentProcessor === "dock";

    return isDock ? !!featureData.is_dock : !!featureData.is_cards;
  } catch (error) {
    console.error("Erro na validação de permissão:", error);
    return false;
  }
};
